import getStore from '../store/store';
import { ApplicationSettingsReport } from '../store/schema/ApplicationSettingsReport';

export default function getApplicationSettingsReport(): ApplicationSettingsReport | undefined {
    return getStore().report;
}
